import { CreateStockArticleDialog } from "@/pages/stock/CreateStockArticleDialog";

interface StockPageIntroProps {
  canManage: boolean;
  onCreated: () => void;
}

export function StockPageIntro({ canManage, onCreated }: StockPageIntroProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
      <p className="max-w-2xl text-sm text-muted-foreground">
        Articles disponibles, mouvements de stock et alertes de seuil pour les opérations de vente.
      </p>
      {canManage && <CreateStockArticleDialog onCreated={onCreated} />}
    </div>
  );
}
